import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CropService } from '../../stores/crop.service';
import { Crop } from 'shared';
import { find } from 'lodash';

@Component({
  selector: 'app-crop-selector',
  templateUrl: './crop-selector.component.html',
  styleUrls: ['./crop-selector.component.scss']
})
export class CropSelectorComponent implements OnInit {

  @Input()
  items?: Crop[];

  @Input()
  value: number;

  @Output()
  valueChange = new EventEmitter<number>();

  @Output()
  selectionChanged = new EventEmitter<Crop>();


  @Input()
  showAddBtn = false;

  selected: Crop;
  isDropDownBoxOpened = false;

  constructor(
    private service: CropService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    if (!this.items) {
      this.items = await this.service.newDataSource({
        paginate: false,
      }).load();
    }

    if (this.value) {
      this.selected = find(this.items, {id: this.value});
    }
  }
  
   ngOnChanges(changes: SimpleChanges) {
    if (this.value) {
      this.selected = find(this.items, { id: this.value });
    }
  }
 
  onItemSelectionChanged(e) {
    this.selected = e.itemData;
    this.isDropDownBoxOpened = false;
    this.valueChange.emit(e.itemData.id);
    this.selectionChanged.emit(e.itemData);
  }
}
